export interface SampleActivity {
    iconUrl: string;
    activityStatus: string;
    activityOccurredonDate: Date;
    collectionDate?: string;
    collectionTime?: string;
    fromLocation: string;
    toLocation: string;
    cancellationDescription: string;
    airwayBillNumber: string;
    hideDescription?: boolean;
    formattedDateTime?: string;
    helptext?: string;
}

export enum ActivityStatus {
    visitcollected = 'Visit Collected'
}